import React from "react";
import { IPaymentTracking } from "../../interfaces/paymentTracking";
import { TableDatabase } from "../../components";
import ChangeStatusComponent from "../../components/paymentCustomerComponents/ChangeStatusComponent";
import * as DetailComponents from "../../components/paymentCustomerComponents/DetailComponents";
import * as Components from "./index.styles";
import HeaderComponent from "../../components/common/HeaderSectionComponent";
import CalendarRangePicker from "../../components/paymentCustomerComponents/ModalDateRange";
import { Spinner } from "react-rainbow-components";
import moment from "moment";
import CheckRefPayment from "../../components/paymentCustomerComponents/CheckRefPayment";
import { getAllPaymentTracking } from "../../services/paymentTracking.service";
import { GetErrorMessage } from "../../functions/error";
import { useError } from "../../store/ErrorModal";
const PaymentCustomerPage = () => {
  const [payment, setPayment] = React.useState<IPaymentTracking[]>([]);
  const [dataForShow, setDataForShow] = React.useState<IPaymentTracking[]>([]);
  const [searchKey, setSearchKey] = React.useState<string>("");
  const [initialDate, setInitialDate] = React.useState<Date>(
    new Date("2021-09-25")
  );
  const [finaleDate, setFinaleDate] = React.useState<Date>(new Date());
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { onError } = useError();
  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const paymentData = await getAllPaymentTracking();
      setPayment(paymentData.data);
    } catch (error: any) {
      onError(GetErrorMessage(error));
    }
    setIsLoading(false);
  }, [onError]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  React.useEffect(() => {
    if (!payment || payment.length === 0) return;
    const formatDate = (date: string | number | Date) =>
      new Date(moment(date).format("YYYY-MM-DD"));
    const dateData = payment.filter((item) => {
      if (
        formatDate(item.timeStamp) < formatDate(initialDate || new Date()) ||
        formatDate(item.timeStamp) > formatDate(finaleDate || new Date())
      )
        return false;
      return true;
    });
    const nData = dateData.filter((item) => {
      item.firstName = item.firstName || "";
      item.lastName = item.lastName || "";
      item.displayName = item.displayName || "";
      const status =
        +item.status === 0
          ? "ยังไม่ชำระเงิน"
          : +item.status === 1
          ? "ชำระเงินแล้ว"
          : +item.status === 2
          ? "กำลังให้บริการ"
          : "";
      return (
        item.firstName.includes(searchKey) ||
        item.lastName.includes(searchKey) ||
        item.displayName.includes(searchKey) ||
        status.includes(searchKey)
      );
    });
    nData.sort(
      (a, b) =>
        new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime()
    );

    setDataForShow(nData);
  }, [searchKey, setSearchKey, initialDate, finaleDate, payment]);

  const convertData = (dataUsers: IPaymentTracking[]) => {
    return dataUsers.map((item: IPaymentTracking, index: number) => [
      <DetailComponents.Timestamp
        key={"Timestamp: " + item.bookingId}
        timestamp={item.timeStamp}
      />,
      <DetailComponents.ProfileComponent
        key={"ProfileComponent: " + item.bookingId}
        name={item.firstName + " " + item.lastName}
        pictureUrl={item.imageUrl}
        displayName={item.displayName}
      />,
      <DetailComponents.Product
        key={"Product: " + item.bookingId}
        productName={item.product.productName}
        productPrice={item.product.price}
        isCoupon={item.isCoupon}
      />,
      <DetailComponents.Description
        key={"Description: " + item.bookingId}
        description={item.descriptions}
        doctorId={item.doctorId}
      />,
      item.isCoupon ? (
        <div
          key={"Coupon: " + item.bookingId}
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={"./coupon.png"}
            alt={`coupon: ${item.productId}`}
            height={40}
            width={40}
            style={{ margin: "0 auto" }}
          />
        </div>
      ) : (
        <CheckRefPayment
          key={"CheckRefPayment: " + item.bookingId}
          refPayment={item.refPayment}
        />
      ),
      <ChangeStatusComponent
        key={"Status: " + item.bookingId}
        status={item.status}
        uid={item.uid}
        bookingId={item.bookingId}
        fetchData={fetchData}
      />,
    ]);
  };

  const header = [
    "วันที่บันทึก",
    "ชื่อลูกค้า",
    "ข้อมูลสินค้า",
    "รายละเอียด",
    "สลิปจ่ายเงิน",
    "สถานะ",
  ];

  return (
    <Components.Container>
      <Components.HeaderSection>
        {HeaderComponent({
          title: "Payment Tracking",
          subheader: "ติดตามสถานะการจ่ายเงินของลูกค้า",
        })}
        <Components.ContainerSeachData>
          <Components.ContainerSearce>
            <p>ค้นหา</p>
            <Components.SearchInput
              placeholder="ชื่อ / ชื่อไลน์ / แพคเกจ / สถานะ"
              onChange={(event) => setSearchKey(event.target.value)}
            />
          </Components.ContainerSearce>
          <CalendarRangePicker
            initalDate={setInitialDate}
            finaleDate={setFinaleDate}
          />
        </Components.ContainerSeachData>
      </Components.HeaderSection>
      <Components.SectionBodyContainer>
        {!isLoading ? (
          <TableDatabase header={header} tableRows={convertData(dataForShow)} />
        ) : (
          <Spinner size="large" />
        )}
      </Components.SectionBodyContainer>
    </Components.Container>
  );
};

export default PaymentCustomerPage;
